module.exports = __webpack_public_path__ + "static/img/tab_logo_home_nor.3850263.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tab_logo_home_nor.png
// module id = ENA+
// module chunks = 26